import { useEffect, useState } from "react";
import { startConnection, sendVote } from "../services/signalr";

export default function Vote() {
    const [session, setSession] = useState(null);
    const [voted, setVoted] = useState(false);

    useEffect(() => {

        startConnection(setSession);

    }, []);

    if (!session) {
        return <h1>Waiting for session...</h1>;
    }

    return (
        <div>
            <h1>Session {session.sessionCode}</h1>

            {session.suggestions.map(vn => (
                <div key={vn.id}>
                    <img src={vn.coverUrl} width={120} alt={`${vn.title} cover`} />
                    <h2>{vn.title}</h2>

                    <button
                        disabled={voted}
                        onClick={() => {
                            sendVote([vn.id]);
                            setVoted(true);
                        }}
                    >
                        Vote
                    </button>

                    <p>Votes: {session.votes[vn.id] ?? 0}</p>
                </div>
            ))}
        </div>
    );
}
